import moment from "moment";
import { SoapRanapResponseItem } from "@/types/soap";

export interface SpriPrefill {
  keluhan_utama: string;
  riwayat_penyakit: string;
  pemeriksaan_fisik: string;
  diagnosis: string;
  terapi: string;
}

const FORMAT_WAKTU = [
  "YYYY-MM-DD HH:mm:ss",
  "YYYY-MM-DDTHH:mm:ss",
  "YYYY-MM-DD"
];

const LABEL_KELUHAN = /^\s*keluhan(\s+utama)?\s*:\s*/i;

function waktuSoap(soap: SoapRanapResponseItem): number {
  const nilai = soap?.examined_at || soap?.created_at;
  if (!nilai) return 0;
  const m = moment(nilai, FORMAT_WAKTU);
  return m.isValid() ? m.valueOf() : 0;
}

export function pickSoapDokterTerakhir(
  list: SoapRanapResponseItem[],
  registerId: string | number
): SoapRanapResponseItem | null {
  if (!Array.isArray(list) || registerId == null) return null;

  const kandidat = list.filter(
    soap =>
      soap &&
      soap.stat === "dr" &&
      String(soap.register_id) === String(registerId)
  );

  if (!kandidat.length) return null;

  return kandidat.sort((a, b) => waktuSoap(b) - waktuSoap(a))[0];
}

export function pecahSubjective(
  subjective: string
): { keluhan_utama: string; riwayat_penyakit: string } {
  const teks = (subjective || "").trim();
  if (!teks) return { keluhan_utama: "", riwayat_penyakit: "" };

  const baris = teks
    .split(/\r?\n/)
    .map(b => b.trim())
    .filter(b => b !== "");

  const idxLabel = baris.findIndex(b => LABEL_KELUHAN.test(b));
  const idx = idxLabel >= 0 ? idxLabel : 0;

  const nilai = baris[idx].replace(LABEL_KELUHAN, "").trim();
  const keluhan = nilai || baris[idx + 1] || teks;
  const sisa = baris.filter((_, i) => i !== idx).join("\r\n");

  return { keluhan_utama: keluhan, riwayat_penyakit: sisa || teks };
}

export function mapSoapToSpri(soap: SoapRanapResponseItem): SpriPrefill {
  const { keluhan_utama, riwayat_penyakit } = pecahSubjective(soap?.subjective);

  return {
    keluhan_utama,
    riwayat_penyakit,
    pemeriksaan_fisik: (soap?.objective || "").trim(),
    diagnosis: (soap?.assesment || "").trim(),
    terapi: (soap?.plan || "").trim()
  };
}

export function adaSoapRegister(
  list: SoapRanapResponseItem[],
  registerId: string | number
): boolean {
  if (!Array.isArray(list) || registerId == null) return false;

  return list.some(
    soap => soap && String(soap.register_id) === String(registerId)
  );
}
